<div class="appoint-call-root">
    <div class="calendar-panel">
        <div class="calendar-header">
            <button mat-icon-button (click)="prevMonth()"><mat-icon>chevron_left</mat-icon></button>
            <div class="month-title">{{ monthNames[displayMonth] }} {{ displayYear }}</div>
            <button mat-icon-button (click)="nextMonth()"><mat-icon>chevron_right</mat-icon></button>
        </div>

        <div class="calendar-scroll">
            <div class="calendar-inner">
                <div class="weekdays">
                    <div *ngFor="let wd of weekDays">{{ wd }}</div>
                </div>

                <div class="days-grid">
                    <span *ngFor="let d of calendarDays" class="day-wrap" [matTooltip]="tooltipFor(d)"
                        [matTooltipDisabled]="!tooltipFor(d)">
                        <button mat-button
                            [disabled]="d.isPast || d.isWeekend || (d.isToday && !(d.hasSlots || d.hasAppointments))"
                            [ngClass]="{ 'other-month': d.otherMonth, 'selected': isSameDate(d.date, selectedDate), 'weekend': d.isWeekend, 'no-slots': (d.hasSlots === false && !d.hasAppointments) }"
                            (click)="selectDate(d.date)">
                            <!-- <span class="dates">{{ d.date.getDate() }}</span>
                        <span *ngIf="(d.appointmentCount ?? 0) > 0" class="appointmentCount">{{d.appointmentCount}}</span>
                            <span *ngIf="d.hasAppointments" class="appointment-dot" [ngClass]="{
                                'pending': d.appointmentStatus === 'pending',
                                'approved': d.appointmentStatus === 'approved'
                        }" aria-hidden="true"></span> -->

                            <span class="demo-section dates custom-badge" [matBadge]="d.appointmentCount ?? 0"
                                [matBadgeHidden]="(d.appointmentCount ?? 0) === 0" matBadgeSize="medium"
                                matBadgeOverlap="false" matBadgeColor="primary" matBadgePosition="above after"
                                [matTooltip]="badgeTooltip(d)" (click)="onBadgeClick($event, d.date)">
                                {{ d.date.getDate() }}
                            </span> </button>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="slot-panel">
        <div *ngIf="selectedDate" class="selected-header">
            <div class="selected-header__left">
                <div class="selected-header__title">{{ selectedDate | date:'EEEE, MMMM d, yyyy' }}</div>
                <div class="selected-header__meta" *ngIf="selectedDate && activeTab === 'available'">You have <strong>{{
                        availableSlotsFor(selectedDate).length }}</strong> available slot(s) on this date</div>
            </div>
            <div class="selected-header__right">
                <div class="selected-slot-chip"
                    *ngIf="activeTab === 'available' && selectedSlot && selectedDate && availableSlotsFor(selectedDate).length > 0">
                    {{ selectedSlot }}</div>
                <div class="selected-slot-chip muted"
                    *ngIf="activeTab === 'available' && !selectedSlot && selectedDate && availableSlotsFor(selectedDate).length > 0">
                    No slot selected</div>
            </div>
        </div>
        <div *ngIf="!selectedDate" class="selected-header">
            <div class="selected-header__title">Select a date to view available slots or Scheduled appointments.</div>
        </div>

        <div *ngIf="selectedDate" class="slots-panel">

            <div *ngIf="availableSlotsFor(selectedDate).length === 0 && bookedAppointmentsFor(selectedDate).length === 0"
                class="muted empty-state">No available slots or scheduled appointments on this date.</div>

            <div
                *ngIf="!(availableSlotsFor(selectedDate).length === 0 && bookedAppointmentsFor(selectedDate).length === 0)">
                <mat-tab-group #tabGroup [(selectedIndex)]="activeTabIndex" (selectedIndexChange)="onTabChange($event)">
                    <mat-tab label="Available">
                        <div *ngIf="selectedDate">
                            <div *ngIf="availableSlotsFor(selectedDate).length > 0; else noSlots">
                                <div class="slots-container">
                                    <div class="slots two-cols two-by-three">
                                        <ng-container *ngFor="let s of availableSlotsFor(selectedDate)">
                                            <button mat-stroked-button color="primary" class="slot-item"
                                                (click)="selectSlot(s)" [ngClass]="{ 'active': selectedSlot === s }">{{
                                                s
                                                }}</button>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noSlots>
                                <div class="muted">No available slots on this date.</div>
                            </ng-template>
                        </div>
                    </mat-tab>
                    <mat-tab label="Scheduled Appointments">
                        <div class="booked-tab">
                            <ng-container *ngIf="bookedAppointmentsFor(selectedDate).length > 0; else none">
                                <div class="booked-list-grid">
                                    <ng-container *ngFor="let appt of filteredBookedAppointmentsFor(selectedDate)">
                                        <div class="booked-wrapper">
                                            <div class="details-card booked-inline">
                                                <div class="status-bar"
                                                    [ngClass]="'status-' + (appt.status || 'pending')"
                                                    aria-hidden="true"></div>
                                                <div class="details-header">
                                                    <div class="time">{{ appt.slot }}</div>
                                                    <div *ngIf="appt.status" class="statusTheme" [ngClass]="{
                                                    'pending': appt.status === 'pending',
                                                    'approved': appt.status === 'approved',
                                                }">{{ appt.status }}</div>
                                                </div>
                                                <div class="details-body">
                                                    <h4 matTooltip="{{ appt.agenda }}"> {{ expanded[appt.createdAt] ?
                                                        appt.agenda : (appt.agenda | slice:0:20) }}
                                                        <span *ngIf="appt.agenda.length > 20">
                                                            <button class="toggle-btn"
                                                                (click)="toggleAgenda(appt.createdAt)">
                                                                {{ expanded[appt.createdAt] ? 'Show less' : '....Show
                                                                more' }}
                                                            </button>
                                                        </span>
                                                    </h4>
                                                    <p class="meta">Scheduled at: {{ appt.createdAt | date:'short' }}
                                                    </p>
                                                    <p *ngIf="appt.notes">Notes: {{ appt.notes }}</p>
                                                    <!-- <p class="meta">Status: <strong>{{ appt.status }}</strong></p> -->
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-template #none>
                                <div class="muted">No scheduled events on this date.</div>
                            </ng-template>
                            <!-- Cancel action visible in Booked view -->
                            <div class="booked-actions"
                                *ngIf="selectedDate && (filteredBookedAppointmentsFor(selectedDate).length > 0) && activeTab === 'scheduled appointments'">
                                <div class="actions">
                                    <button class="site-btn site-btn--link" type="button" aria-label="Cancel"
                                        (click)="reset()">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>

        <ng-container *ngIf="selectedDate && availableSlotsFor(selectedDate).length > 0 && activeTab === 'available'">
            <div class="form-row" style="width:100%; margin-top:12px;">
                <label for="agendaInput">Agenda <span class="required-asterisk">*</span></label>
                <input id="agendaInput" type="text" [(ngModel)]="agenda" placeholder="Enter meeting agenda" class="agenda-input"
                    (paste)="preventPaste($event)" (copy)="preventCopy($event)" (cut)="preventCut($event)"
                    (keydown.enter)="$event.preventDefault(); submit()">
            </div>

            <div class="actions">
                <button *ngIf="selectedDate && selectedSlot && agenda && agenda.trim().length > 0"
                    class="site-btn site-btn--primary" (click)="submit()">Schedule Call</button>
                <button class="site-btn site-btn--link" type="button" aria-label="Cancel"
                    (click)="reset()">Cancel</button>
            </div>
        </ng-container>
    </div>
</div>